import React, { memo, useMemo, useState } from 'react';
import { history } from 'umi';
import { Card, Radio } from 'tea-component';
import Loading from '@gp/components/Loading';
import InfoBubble from '@gp/components/InfoBubble';
import NoData from '@gp/components/NoData';
import SimpleCard from './components/SimpleCard';
import LiveCard from './components/LiveCard';
import InDevCard from './components/InDevCard';
import { getLocationIsValid, getValidDate } from '@gp/utils/common';
import { SLASH_G_POP } from '@gp/constants/const';
import './index.scss';
import CardSlot from '@/pages/globalpedia/components/CardSlot';
import useProjects from '@gp/pages/Pipeline/ProjectDetails/_hooks/useProjects';

// 无数据时的高度，设计稿要求整高200px
const NO_DATA_HEIGHT_LIVE = 132;
const NO_DATA_HEIGHT_IN_DEVELOPMENT = 172;

interface ProjectsPropsType {
  // loading: boolean;
  projectsLiveLoading: boolean;
  projectsInDevLoading: boolean;
  liveData: any;
  inDevData: any;
  onProjectLiveChange:
    | ((
        params: {
          studio_id: string;
          internal: boolean | undefined;
        },
        type: string, // internal | intelligence
      ) => void)
    | null;
}

const DEFAULT_PROPS: ProjectsPropsType = {
  // loading: true,
  projectsLiveLoading: true,
  projectsInDevLoading: true,
  liveData: null,
  inDevData: null,
  onProjectLiveChange: null,
};

function Projects(props: ProjectsPropsType) {
  const {
    // loading,
    projectsLiveLoading,
    projectsInDevLoading,
    liveData,
    inDevData,
    onProjectLiveChange,
  } = props;

  const filterObj: any = getLocationIsValid('/Studio/PortfolioOverview') || {};

  const { projects } = useProjects();

  const [radioCategory, setRadioCategory] = useState<'internal' | 'intelligence'>('internal');

  const navigateFilter = useMemo(() => {
    return {
      ...filterObj,
      tab: 'projects',
    };
  }, [filterObj]);

  const navigate2Projects = (flag: 'live' | 'development', isJump = true) => {
    const filter: any = {
      ...navigateFilter,
      segment: flag,
    };
    if (!filter?.studioId) return '';
    const filterStr = encodeURIComponent(JSON.stringify(filter));
    const url = `${SLASH_G_POP}/Studio/PortfolioOverview/Detail?filter=${filterStr}`;
    if (isJump) {
      history.push(url);
    }

    return url;
  };

  return (
    <CardSlot
      className="dbg-details-overview-projects"
      // className=""
      title="Projects"
    >
      {/* loading */ false && <Loading loading style={{ height: 290 }} />}
      {
        /* loading */ false || (
          <>
            <SimpleCard
              title="Key Titles - Live"
              url={navigate2Projects('live', false)}
              count={liveData?.total}
              isNoData={
                /* !Array.isArray(liveData?.game_detail) || (liveData?.game_detail?.length === 0) */ false
              }
              titleOnClick={() => {
                navigate2Projects('live');
              }}
            >
              {liveData?.data_time ? (
                <div className="overview-simple-time">
                  Data Time: {getValidDate(liveData?.data_time, 'YYYY-MM')}
                </div>
              ) : null}
              <Radio.Group
                className="key-title-live-radio-select"
                value={radioCategory}
                onChange={(v: string) => {
                  setRadioCategory(v as 'internal' | 'intelligence');
                  onProjectLiveChange?.(
                    {
                      studio_id: filterObj?.studioId,
                      internal: v == 'internal' ? true : undefined,
                    },
                    v,
                  );
                }}
              >
                <Radio name="internal">
                  <InfoBubble
                    className="globalpedia-modal-font14"
                    DomOrText="Internal"
                    customBubbleContent="Work for hire projects with studio involvement are not included."
                  />
                </Radio>
                <Radio name="intelligence">
                  <InfoBubble
                    className="globalpedia-modal-font14"
                    DomOrText="Intelligence"
                    customBubbleContent="All projects in which the studio is involved in R&D and published are included."
                  />
                </Radio>
              </Radio.Group>
              {projectsLiveLoading && (
                <Loading loading style={{ height: NO_DATA_HEIGHT_LIVE, marginBottom: 20 }} />
              )}
              {!projectsLiveLoading && (
                <>
                  {!Array.isArray(liveData?.game_detail) || liveData?.game_detail?.length === 0 ? (
                    <NoData constomStyle={{ height: NO_DATA_HEIGHT_LIVE, fontSize: 14 }} />
                  ) : (
                    <div className="key-title-live-card-group">
                      {liveData?.game_detail?.map((t: any, i: number) => {
                        return i < 4 ? (
                          <LiveCard
                            key={t?.id}
                            category={radioCategory}
                            data={t}
                            projects={projects}
                          />
                        ) : null;
                      })}
                    </div>
                  )}
                </>
              )}
            </SimpleCard>
            <SimpleCard
              // style={{marginTop: 10}}
              title="Key Titles - In Development"
              url={navigate2Projects('development', false)}
              count={inDevData?.total}
              noDataCustomHeight={NO_DATA_HEIGHT_IN_DEVELOPMENT}
              isNoData={
                !Array.isArray(inDevData?.game_detail) || inDevData?.game_detail?.length === 0
              }
              titleOnClick={() => {
                navigate2Projects('development');
              }}
            >
              <div className="overview-simple-time">
                Data Time: {getValidDate(inDevData?.data_time, 'YYYY-MM')}
              </div>
              {projectsInDevLoading && (
                <Loading
                  loading
                  style={{ height: NO_DATA_HEIGHT_IN_DEVELOPMENT, marginBottom: 20 }}
                />
              )}
              {/* <div className="overview-simple-time">Data Time: 2023-10</div> */}
              {projectsInDevLoading || (
                <div className="key-title-in-dev-card-group">
                  {inDevData?.game_detail?.map((t: any, i: number) => {
                    return i < 6 ? (
                      <InDevCard
                        key={t?.id}
                        data={t}
                        projects={projects}
                        style={{
                          width:
                            inDevData?.game_detail?.length < 3 ? 'calc((100% - 20px) / 2)' : '',
                          marginRight: inDevData?.game_detail?.length < 3 && i === 1 ? '0px' : '',
                          marginBottom: inDevData?.game_detail?.length > 3 ? '' : '0px',
                        }}
                      />
                    ) : null;
                  })}
                </div>
              )}
            </SimpleCard>
          </>
        )
      }
    </CardSlot>
  );
}

Projects.defaultProps = DEFAULT_PROPS;

export default memo(Projects);
